import { CompliancePrompt } from '../components/compliance-prompt/compliance-prompt';

import { useComplianceChange } from './use-compliance-change';

export enum BlockType {
    WAGER = 'wager',
    DEPOSIT = 'deposit',
    WITHDRAWAL = 'withdrawal',
    GEOLOCATION = 'geolocation',
}

function switchBlockType(
    conditions: {
        isWageringAllowed: boolean;
        isDepositAllowed: boolean;
        isWithdrawAllowed: boolean;
    },
    type: BlockType,
) {
    switch (type) {
        case BlockType.WAGER:
            return conditions.isWageringAllowed;
        case BlockType.DEPOSIT:
            return conditions.isDepositAllowed;
        case BlockType.WITHDRAWAL:
            return conditions.isWithdrawAllowed;
    }
}

export function useCompliancePrompt(type: BlockType) {
    const changeData = useComplianceChange();
    const complianceTypeAllowed = switchBlockType(changeData, type);

    if (complianceTypeAllowed) {
        return {
            prompt: null,
        };
    }

    return {
        prompt: <CompliancePrompt blockType={type} />,
    };
}
